<mat-spinner diameter="60" strokeWidth="3" color=""></mat-spinner>
<div class="message-container">
  <app-body-md bold>We are recalculating your payroll</app-body-md>
  <app-body-md>This may take a few moments</app-body-md>
</div>
